import { IUserDisplayData } from '@gem/models/userModel';

export interface IReminder {
  type: ReminderType;
  time: number;
  unit: string;
}

export interface IParticipant {
  email: string;
  confirmationType: ConfirmationType;
}

export interface ICalendarAccount {
  providerEmail: string;
  type?: CalendarType;
}

// TODO: rename to ICalendarEvent
export interface IEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  initiatorEmail: string;
  allDay: boolean;
  timeZone: string;
  location: string;
  description: string;
  recurrenceType: string;
  chatLink: string;
  callLink: string;
  reminders: IReminder[];
  parentId: string;
  providerEventId: string;
  participants: IParticipant[];
  account: ICalendarAccount;
}

// TODO: move types from IEvent
export interface ICalendarEvent extends IEvent {}

export interface ICalendarCredentialParams {
  code: string;
  redirectUri: string;
}

export interface IGetCalendarEventsParams {
  from: bigint;
  to: bigint;
}

export interface IDeleteCalendarEventParams {
  providerEventId: string;
  account: ICalendarAccount;
}

export interface IDeleteRecurrenceEventParams {
  parentId: string;
  account: ICalendarAccount;
}

export interface ICreateCalendarEventParams {
  title: string;
  startTimeTs: bigint;
  endTimeTs: bigint;
  allDay: boolean;
  timeZone: string;
  location: string;
  description: string;
  recurrenceType: string;
  chatLink: string;
  callLink: string;
  reminders: Array<{
    type: ReminderType;
    time: bigint;
  }>;
  participantEmails: string[];
  account: ICalendarAccount;
}

export interface IUpdateCalendarEventParams {
  providerEventId: string;
  title: string;
  startTimeTs: bigint;
  endTimeTs: bigint;
  allDay: boolean;
  timeZone: string;
  location: string;
  description: string;
  chatLink: string;
  callLink: string;
  reminders: Array<{
    type: ReminderType;
    time: bigint;
  }>;
  participantEmails: string[];
  account: ICalendarAccount;
}

export interface IUpdateRecurrenceCalendarEventParams {
  parentId: string;
  title: string;
  startTimeTs: bigint;
  endTimeTs: bigint;
  allDay: boolean;
  timeZone: string;
  location: string;
  description: string;
  recurrenceType: string;
  chatLink: string;
  callLink: string;
  reminders: Array<{
    type: ReminderType;
    time: bigint;
  }>;
  participantEmails: string[];
  account: ICalendarAccount;
}

export enum CalendarRealtimeAction {
  UPDATE = 'update',
  DELETE = 'delete',
  CREATE = 'create',
  UNKNOWN = 'unknown',
}

export interface ICalendarEventUpdate {
  event: IEvent | null;
  action: CalendarRealtimeAction;
}

export interface ISubscribeToCalendarPushParams {
  accounts: ICalendarAccount[];
}

export interface ILogoutCalendarParams {
  account: ICalendarAccount;
}

export interface IUpdateEventParticipantStatusParams {
  providerEventId: string;
  confirmationType: ConfirmationType;
  account: ICalendarAccount;
}

export interface ICalendarAuthAccount {
  account: ICalendarAccount;
  isActive: boolean;
}

export interface ISearchUsersAddToCalendarEventParams {
  query: string;
  cursor?: string;
  limit?: number;
  emails: string[];
}

export interface ISearchUsersAddToCalendarEventResult {
  cursor?: string;
  users: IUserDisplayData[];
}
export interface ISetCompactCalendarViewParams {
  isCompact: boolean;
}

export interface IUserSettings {
  isCompact: boolean;
  timeFrom: bigint;
  timeTo: bigint;
}

export enum CalendarType {
  GOOGLE = 0,
  YANDEX = 1,
  EWS = 2,
}

export enum ReminderType {
  UNKNOWN = 0,
  POPUP = 1,
  EMAIL = 2,
}

export enum ConfirmationType {
  NO_ANSWER = 0,
  ACCEPTED = 1,
  DECLINED = 2,
  MAYBE = 3,
}

export enum CalendarModelErrorCode {
  Unauthorized = 'E_UNAUTHORIZED',
  Forbidden = 'E_FORBIDDEN',
}

export interface IGetCalendarAuthUrlParams {
  type: CalendarType;
  redirectUri: string;
}
